.live {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}

.liveItem {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px 8px 8px;
  border-radius: 14px;
  font-weight: 400;
  text-align: left;
  background: color-mix(in srgb, var(--accent) 8%, var(--surface));
  background-image: none;
  color: var(--text);
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--accent) 40%, var(--line));
}

.liveItem:disabled {
  opacity: 1;
  cursor: default;
  color: var(--muted);
}

.liveItem img,
.liveItem .backStd {
  width: 26px;
  aspect-ratio: 180 / 314;
  object-fit: contain;
}

.liveItem small {
  display: block;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--muted);
}

.backStd {
  display: block;
  flex: none;
  aspect-ratio: 180 / 314;
  border-radius: 5px;
  background: linear-gradient(120deg, color-mix(in srgb, var(--accent) 25%, var(--surface)), var(--accent), color-mix(in srgb, var(--accent) 25%, var(--surface)));
}

.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 14px;
  margin-bottom: 14px;
}

.search {
  width: 240px;
  max-width: 100%;
}

.tableWrap {
  border-radius: 18px;
  background: color-mix(in srgb, var(--surface) 85%, transparent);
  box-shadow: inset 0 0 0 1px var(--line);
  overflow: hidden;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
}

.table th {
  padding: 12px 14px;
  text-align: left;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--muted);
  border-bottom: 1px solid var(--line);
}

.table td {
  padding: 12px 14px;
  vertical-align: middle;
  border-bottom: 1px solid var(--line);
}

.table tbody tr {
  cursor: pointer;
}

.table tbody tr:last-child td {
  border-bottom: 0;
}

.table tbody tr:hover td {
  background: var(--pill-bg);
}

.name {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  color: var(--text);
}

.name img,
.name .backStd {
  width: 32px;
  flex: none;
  aspect-ratio: 180 / 314;
  border-radius: 5px;
  border: 1px solid var(--line);
  object-fit: contain;
}

.name img {
  border: 0;
  border-radius: 0;
}

.name b {
  display: block;
  font-weight: 500;
  overflow-wrap: anywhere;
}

.name small {
  display: block;
  font-size: 12px;
  color: var(--muted);
}

.kind {
  display: inline-flex;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  white-space: nowrap;
  color: var(--text);
  box-shadow: inset 0 0 0 1px var(--line);
}

.kind[data-kind='daily_card'] {
  color: var(--accent);
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--accent) 50%, transparent);
}

.progress {
  display: grid;
  gap: 5px;
  min-width: 110px;
  font-size: 13px;
}

.bar {
  display: block;
  height: 5px;
  border-radius: 9px;
  background: var(--line);
  overflow: hidden;
}

.bar i {
  display: block;
  height: 100%;
  background: var(--ok);
}

.bar i.barPart {
  background: var(--accent);
}

.badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.default {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  white-space: nowrap;
  background: var(--fill);
  background-image: var(--fill-gradient);
  color: var(--on-fill);
}

.owner {
  color: var(--muted);
}

.empty {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: center;
  padding: 28px;
  border-radius: 18px;
  color: var(--muted);
  border: 1px dashed var(--line);
}

@media (max-width: 640px) {
  .search {
    width: 100%;
  }

  .table thead {
    display: none;
  }

  .table,
  .table tbody,
  .table tr,
  .table td {
    display: block;
  }

  .table tr {
    padding: 10px 14px;
    border-bottom: 1px solid var(--line);
  }

  .table tbody tr:last-child {
    border-bottom: 0;
  }

  .table td {
    padding: 4px 0;
    border: 0;
  }

  .table td[data-label] {
    display: grid;
    grid-template-columns: 70px minmax(0, 1fr);
    gap: 10px;
    align-items: center;
  }

  .table td[data-label]::before {
    content: attr(data-label);
    font-size: 12px;
    color: var(--muted);
  }
}
